import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

export default function HeroVideo() {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);

  useEffect(() => {
    const v = ref.current;
    const events = ["pointerdown", "keydown", "touchstart"];
    const unmute = () => {
      events.forEach((e) => window.removeEventListener(e, unmute));
      v.muted = false;
      setMuted(false);
      if (v.paused) v.play().catch(() => {});
    };
    if (navigator.userActivation?.hasBeenActive) unmute();
    else events.forEach((e) => window.addEventListener(e, unmute));
    return () => events.forEach((e) => window.removeEventListener(e, unmute));
  }, []);

  const toggle = (e) => {
    e.stopPropagation();
    const v = ref.current;
    v.muted = !v.muted;
    setMuted(v.muted);
    if (!v.muted) v.play().catch(() => {});
  };

  return (
    <div className="absolute z-0 inset-x-0 top-16 lg:inset-x-auto lg:right-[3%] lg:top-1/2 lg:-translate-y-1/2 w-full lg:w-[min(760px,56vw)] aspect-video" data-testid="hero-video-panel">
      <video ref={ref} className="absolute inset-0 w-full h-full object-cover" poster="/brand/hero_poster.jpg" autoPlay muted loop playsInline preload="auto" data-testid="hero-video">
        <source src="/brand/hero.mp4" type="video/mp4" />
        <source src="/brand/hero.webm" type="video/webm" />
      </video>
      <div className="absolute inset-0 bg-[#14081C]/55 lg:bg-transparent lg:bg-gradient-to-r lg:from-[#14081C] lg:via-[#14081C]/30 lg:to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#14081C] to-transparent" />
      <div className="hidden lg:block absolute inset-x-0 top-0 h-1/4 bg-gradient-to-b from-[#14081C] to-transparent" />
      <button onClick={toggle} className="absolute z-20 bottom-3 right-3 w-11 h-11 grid place-items-center rounded-full bg-black/50 border border-white/25 text-white hover:bg-[#D4AF37] hover:text-[#14081C] transition-colors" aria-label={muted ? "Turn sound on" : "Turn sound off"} data-testid="hero-sound-toggle">
        {muted ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
      </button>
    </div>
  );
}
